import React, { useEffect } from "react";

import { ModalHeader } from "@common/components/Modal/ModalHeader/ModalHeader";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useAuthContext } from "@main/context/Auth/Auth.context";

export function AIFeedbackModal({ onCancel, userFeedbackId }: { onCancel: () => void; userFeedbackId?: string }) {
  const { userData } = useAuthContext();
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    const tallyObject = Tally;
    if (!tallyObject) return;

    tallyObject.loadEmbeds();
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore
    const tallyObject = Tally;
    if (!tallyObject) return;

    // eslint-disable-next-line
    function handler(event: MessageEvent<any>) {
      if (typeof event.data !== "string") return;
      if (!event.data.includes("Tally.FormSubmitted")) return;
      onCancel();
    }

    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, [onCancel]);

  const formURL = `https://forms.shakebugs.com/sheldon_feedback?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&userId=${userData?.id}&workspaceId=${selectedWorkspace?.id}&appId=${selectedApp?.id}&issueId=${userFeedbackId}`;
  return (
    <>
      <ModalHeader heading="Send feedback on Sheldon's answer" />
      <iframe
        data-tally-src={formURL}
        loading="lazy"
        onLoad={() => {
          /// iFrame loaded
          return;
        }}
        frameBorder="0"
        width="100%"
        height="380"
      ></iframe>
    </>
  );
}
